<template>
  <NavBar @scrollTo="scrollTo" />
  <HeroSection />
  <PostSection />
  <AboutSection />
  <FeedbackSection />
  <TeamSection />
  <ContactSection />
  <FooterSection />
</template>

<script>
import HeroSection from "@/components/website/welcome/HeroSection.vue";
import AboutSection from "@/components/website/welcome/AboutSection.vue";
import FeedbackSection from "@/components/website/welcome/FeedbackSection.vue";
import PostSection from "@/components/website/welcome/PostSection.vue";
import TeamSection from "@/components/website/welcome/TeamSection.vue";
import ContactSection from "@/components/website/welcome/ContactSection.vue";
import FooterSection from "@/components/website/welcome/FooterSection.vue";
import NavBar from "@/components/website/NavBar.vue";
export default {
  components: {
    NavBar,
    HeroSection,
    AboutSection,
    PostSection,
    TeamSection,
    ContactSection,
    FooterSection,
    FeedbackSection,
  },
  methods: {
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
